import { AvatarSize } from '@bechtel/gds';
import { CrewMember, PersonaType } from '@bechtel/types';

export interface CrewMemberExt extends CrewMember {
  isAffected?: boolean;
  showArrow?: boolean;
  avatarSize?: AvatarSize;
  hideTreeLine?: boolean;
  title: string;
}

export interface CrewTreeProps {
  crewMembers: CrewMemberExt[];
  showAffectedCrewMembers?: boolean;
  label: string;
}

export interface CrewNodeProps {
  crewMember: CrewMemberExt;
  gridRowLocation: number;
  showAffected?: boolean;
  isLastNode: boolean;
}

export const MockForemanId = 'MockForemanId';
export const MockGeneralForemanId = 'MockGeneralForemanId';
export const MockSuperintendentId = 'MockSuperintendentId';

export const personaTypes = [PersonaType.FOREMAN, PersonaType.GENERAL_FOREMAN, PersonaType.SUPERINTENDENT];
